import AxiosInstance from './axios/interceptor';

const controller = 'Event';

export interface EventFormSetting {
  id: number;
  eventID: number;
  fieldName: string;
  heading: string;
  show: boolean;
  required: boolean;
  locked: boolean;
  type: number;
  extra: string;
  extraOptions?: EventExtraOption[];
  validator: string;
  errorMessage: string;
  fieldSize: number;
  row: number;
  col: number;
}

export interface EventExtraOption {
  name: string;
  value: string;
}

export interface EventFormSettingRequest {
  fieldName: string;
  heading: string;
  show: boolean;
  required: boolean;
  locked: boolean;
  type: number;
  extra: string;
  validator: string;
  errorMessage: string;
  fieldSize: number;
  row: number;
  col: number;
}

export enum EventFormFieldType {
  Text = 1,
  Multiline = 2,
  Readonly = 3,
  Dropdown = 4,
  Checkbox = 7,
  Label = 21,
}

export const fieldTypeLabels: Record<number, string> = {
  [EventFormFieldType.Text]: 'event:formSettings.fieldTypes.text',
  [EventFormFieldType.Multiline]: 'event:formSettings.fieldTypes.multiline',
  [EventFormFieldType.Dropdown]: 'event:formSettings.fieldTypes.dropdown',
  [EventFormFieldType.Checkbox]: 'event:formSettings.fieldTypes.checkbox',
  [EventFormFieldType.Label]: 'event:formSettings.fieldTypes.label',
};

export const getFormSettings = (eventId: number) => {
  return AxiosInstance.get<EventFormSetting[]>(`${controller}/${eventId}/FormSettings`);
};

export const createFormSetting = (eventId: number, data: EventFormSettingRequest) => {
  return AxiosInstance.post(`${controller}/${eventId}/FormSettings`, data);
};

export const updateFormSetting = (eventId: number, fieldId: number, data: EventFormSettingRequest) => {
  return AxiosInstance.put(`${controller}/${eventId}/FormSettings/${fieldId}`, data);
};

export const deleteFormSetting = (eventId: number, fieldId: number) => {
  return AxiosInstance.delete(`${controller}/${eventId}/FormSettings/${fieldId}`);
};
